import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IViewComponent} from '../../../../../interface/panels';
import { NoosFormTypeService} from '../../../../../class/NoosFormTypeService';
import {IFormItems} from '../../../../../interface/form-structure';


@Component({
    // tslint:disable-next-line:component-selector
    selector: 'noos-form-container-masterlist',
    templateUrl: './form-container-masterlist.component.html',
    styleUrls: ['./form-container-masterlist.component.scss']
})

@NoosFormTypeService.register('ViewFORMmasterlist')
export class FormContainerMasterlistComponent implements OnInit, IViewComponent, AfterViewInit {


    formJson: IFormItems[];
    isFilter: boolean;

    @Output()
    keyOnEnter = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    constructor() {
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
    }


    onEnterEvent($event: any) {
        this.keyOnEnter.emit();
    }
}
